import { render, staticRenderFns } from "./presentation-slide-grid.vue?vue&type=template&id=1fb04d10&scoped=true&"
import script from "./presentation-slide-grid.vue?vue&type=script&lang=js&"
export * from "./presentation-slide-grid.vue?vue&type=script&lang=js&"
import style0 from "./presentation-slide-grid.vue?vue&type=style&index=0&id=1fb04d10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb04d10",
  null
  
)

export default component.exports